import React, { useContext } from "react";
import { WATaskSingleContext } from "../WATaskSingleContext";
import { WATaskSingleSettingsScreenProps } from "../WATaskSingleStack";
import { WidgetTaskSingleSettingsScreenComponent } from "../../WidgetTaskSingleSettingsScreenComponent";
import { LazyQueryNetworkBoundrary } from "../../../../../../../components/mobile/QueryNetworkBoundrary";
import { graphql, useLazyLoadQuery } from "react-relay";
import { WATaskSingleSettingsScreenQuery } from "./__generated__/WATaskSingleSettingsScreenQuery.graphql";

type Props = WATaskSingleSettingsScreenProps<"WATaskSingleSettings">;

const WA_TASK_SINGLE_SETTINGS_SCREEN_QUERY = graphql`
  query WATaskSingleSettingsScreenQuery($taskId: ID!) {
    task(id: $taskId) {
      ...WidgetTaskSingleSettingsScreenComponent_task
    }
  }
`;

export function WATaskSingleSettingsScreen(props: Props) {
  return (
    <LazyQueryNetworkBoundrary>
      {(fetchKey) => (
        <InnerWATaskSingleSettingsScreen {...props} fetchKey={fetchKey} />
      )}
    </LazyQueryNetworkBoundrary>
  );
}

function InnerWATaskSingleSettingsScreen(props: Props & { fetchKey: string }) {
  const context = useContext(WATaskSingleContext);
  const data = useLazyLoadQuery<WATaskSingleSettingsScreenQuery>(
    WA_TASK_SINGLE_SETTINGS_SCREEN_QUERY,
    {
      taskId: context.taskId ?? "",
    },
    { fetchKey: props.fetchKey }
  );

  if (context.taskId === null) {
    return null;
  }

  return (
    <WidgetTaskSingleSettingsScreenComponent
      task={data.task!}
      sectionIds={context.sectionIds}
      setSectionIds={context.setSectionIds}
      storecastId={context.storecastId}
      taskId={context.taskId}
    />
  );
}
